<a class="logo d-flex align-items-center text-decoration-none mt-3" [routerLink]="['/']">
  <img src="assets/img/logo-small.png" />
  <span *ngIf="!isCollapsed" class="fs-4">CMS</span>
</a>
<hr />

<nav class="nav nav-pills flex-column">
  <span class="fs-6 text-uppercase fw-bold opacity-75">
    <ng-container *ngIf="!isCollapsed">Administration</ng-container>
  </span>

  <a *ngIf="canReadDashboard" class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="chart-line"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Dashboard</ng-container>
  </a>
  <a *ngIf="hasDashboardAccessControl" class="nav-link" routerLinkActive="active" [routerLink]="['/access_control']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="lock"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Dashboard Access</ng-container>
  </a>
  <a *ngIf="hasUserControl" class="nav-link" routerLinkActive="active" [routerLink]="['/users']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="user"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Users</ng-container>
  </a>
  <a *ngIf="hasUserControl" class="nav-link" routerLinkActive="active" [routerLink]="['/whitelist']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="address-card"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Whitelist</ng-container>
  </a>
  <a *ngIf="hasUserControl" class="nav-link" routerLinkActive="active" [routerLink]="['/licence']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="key"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Licence</ng-container>
  </a>
  <a *ngIf="hasRoleControl" class="nav-link" routerLinkActive="active" [routerLink]="['/roles']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="user-graduate"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Roles</ng-container>
  </a>
  <a *ngIf="hasUserControl" class="nav-link" routerLinkActive="active" [routerLink]="['/audit/users']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="book-user"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Audit Logs</ng-container>
  </a>
  <a *ngIf="hasShopControl" class="nav-link" routerLinkActive="active" [routerLink]="['/shopify']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="shopping-basket"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Shopify</ng-container>
  </a>
  <a *ngIf="hasVRSpeechControl" class="nav-link" routerLinkActive="active" [routerLink]="['/vrspeech']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="head-vr"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> VR-Speech</ng-container>
  </a>
  <a *ngIf="hasBookingControl" class="nav-link" routerLinkActive="active" [routerLink]="['/events']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="calendar"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Events</ng-container>
  </a>
  <a *ngIf="hasReportsAccess" class="nav-link" routerLinkActive="active" [routerLink]="['/reports']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="chart-bar"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Reports</ng-container>
  </a>
</nav>
<hr />

<ng-container *ngIf="multiLanguage && !isCollapsed">
  <span class="fs-6 text-uppercase text-nowrap fw-bold opacity-75 form-group row">
    <label class="col col-form-label" for="language"> Language </label>
    <div class="col col-form mt-1">
      <select
        class="form-select form-select-sm"
        id="language"
        style="font-weight: bold"
        [ngModel]="cms.language"
        (ngModelChange)="switchLanguage($event)"
      >
        <option *ngFor="let o of cms.languages" style="font-weight: normal">{{ o }}</option>
      </select>
    </div>
  </span>
  <hr />
</ng-container>

<nav class="nav nav-pills flex-column">
  <span class="fs-6 text-uppercase fw-bold opacity-75">
    <ng-container *ngIf="!isCollapsed">Content</ng-container>
  </span>

  <a *ngIf="hasConfigurationControl" class="nav-link" routerLinkActive="active" [routerLink]="['/configuration']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="cog"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> App Configurator</ng-container>
  </a>
  <a *ngIf="hasAccessControl" class="nav-link" routerLinkActive="active" [routerLink]="['/permission']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="user-shield"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Access Control</ng-container>
  </a>
  <a *ngIf="hasAchievement" class="nav-link" routerLinkActive="active" [routerLink]="['/achievement']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="trophy"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Achievement</ng-container>
  </a>
  <a *ngIf="hasJourney" class="nav-link" routerLinkActive="active" [routerLink]="['/journey']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="route"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Journey</ng-container>
  </a>
  <a *ngIf="hasSurveys" class="nav-link" routerLinkActive="active" [routerLink]="['/survey']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="poll"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Survey</ng-container>
  </a>
  <a *ngIf="hasChat" class="nav-link" routerLinkActive="active" [routerLink]="['/chat']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="comments"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Chat</ng-container>
  </a>
  <a *ngIf="hasVimeo" class="nav-link" routerLinkActive="active" [routerLink]="['/vimeo']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="video"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Vimeo</ng-container>
  </a>
  <a class="nav-link" routerLinkActive="active" [routerLink]="['/review']">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="book-open"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Review</ng-container>
  </a>
</nav>
<hr />

<ng-container *ngIf="!isCollapsed">
  <ng-container *ngFor="let mod of modifiers; trackBy: trackByMod">
    <span class="fs-6 text-uppercase fw-bold opacity-75">{{ mod.label }}</span>

    <nav class="nav nav-pills nav-tree flex-column">
      <span *ngIf="canCreate && canCreateModifer(mod)" class="nav-link" role="button" (click)="createModifier(mod)">
        <fa-icon class="icon me-2" [fixedWidth]="true" icon="plus"></fa-icon>
        New
      </span>

      <span *ngFor="let template of templates[mod.name]" class="nav-link" role="button" (click)="createTemplate(template)">
        <fa-icon class="icon me-2" [fixedWidth]="true" icon="plus"></fa-icon>
        {{ template.name }}
      </span>

      <app-sidebar-segment
        *ngFor="let child of children[mod.name]; trackBy: trackByUUID"
        [activePath]="activePath"
        [mode]="mode"
        [node]="child"
      >
      </app-sidebar-segment>
    </nav>
    <hr />
  </ng-container>

  <span class="fs-6 text-uppercase fw-bold opacity-75">Nodes</span>
  <nav class="nav nav-pills nav-tree flex-column mb-auto" *ngIf="root">
    <span *ngFor="let template of templates['none']" class="nav-link" role="button" (click)="createTemplate(template)">
      <fa-icon class="icon me-2" [fixedWidth]="true" icon="plus"></fa-icon>
      {{ template.name }}
    </span>

    <span *ngIf="canCreate" class="nav-link" role="button" (click)="create()">
      <fa-icon class="icon me-2" [fixedWidth]="true" icon="plus"></fa-icon>
      New
    </span>

    <app-sidebar-segment
      *ngFor="let child of children['none']; trackBy: trackByUUID"
      [activePath]="activePath"
      [mode]="mode"
      [node]="child"
    >
    </app-sidebar-segment>
  </nav>
  <hr />
</ng-container>

<nav class="nav nav-pills flex-column" style="margin-bottom: 85px">
  <a class="nav-link" role="button" (click)="logout()">
    <fa-icon class="icon me-2" [fixedWidth]="true" icon="sign-out"></fa-icon>
    <ng-container *ngIf="!isCollapsed"> Log Out </ng-container>
  </a>
  <hr />
</nav>

<div class="sidebar-toggle px-3" [style.width]="sidebarToggleWidthPx">
  <nav class="nav nav-pills mb-2 flex-column">
    <a class="nav-link" role="button" (click)="toggleCollapse()">
      <fa-icon class="icon me-2" [fixedWidth]="true" [icon]="isCollapsed ? 'chevron-double-right' : 'chevron-double-left'"></fa-icon>
      <ng-container *ngIf="!isCollapsed"> Collapse </ng-container>
    </a>
  </nav>
</div>
